export default __webpack_public_path__ + "static/media/spiral.60cef01b.svg";